import { onComposeStateChange } from '../actions/publicActions';
import { closeComposeInSxS, forceCloseSxS } from '../actions/publicLazyActions';
import getOrCreateSxSStoreData from '../store/Store';
import ItemId from 'owa-service/lib/contract/ItemId';
import { orchestrator } from 'satcheljs';
import { isSxSDisplayedWithCompose } from '../utils/isSxSDisplayed';
import findSxSIdByFullComposeId from '../utils/findSxSIdByFullComposeId';
import { findTabIdBySxSId } from 'owa-tab-store';
import getProjection from 'owa-popout-v2/lib/utils/getProjection';

orchestrator(closeComposeInSxS, actionMessage => {
    const { composeViewState } = actionMessage;
    const sxsId = findSxSIdByFullComposeId(composeViewState.composeId);
    if (isSxSDisplayedWithCompose(composeViewState, sxsId)) {
        let shouldCloseSxS = false;
        const sxsStore = getOrCreateSxSStoreData(sxsId);
        if (composeViewState && composeViewState.composeId === sxsStore.composeId) {
            onComposeStateChange(null, sxsId);

            if (!sxsStore.readingPaneState) {
                shouldCloseSxS = true;
            }
        }

        const composeItemId: ItemId = composeViewState?.itemId;
        const previewItemId = sxsStore.editState?.itemId;

        if (composeItemId && previewItemId && composeItemId.Id === previewItemId.Id) {
            shouldCloseSxS = true;
        }

        if (shouldCloseSxS) {
            const tabId = findTabIdBySxSId(sxsId);
            const targetWindow: Window = getProjection(tabId)?.window || window;
            // we also need to close the window that hosts SxS if the window is not main window
            const shouldCloseWindow = targetWindow !== window;
            forceCloseSxS('closeCompose', sxsId, shouldCloseWindow);
        }
    }
});
